function getDefaultConfig() {
  return {
    defaultName: 'default',
    defaultDragAndDrop: true,
    defaultDebug: false,
    defaultDragHandlerSelector: '.card-holder__toolbar, .card-holder__title, .card-holder__menu-container',
    layoutOptions: {
      small: {
        breakpoint: 0,
        minCardSize: 12,
        maxCardSize: 12,
        defaultHeight: 368,
      },
      medium: {
        breakpoint: 1046,
        minCardSize: 6,
        maxCardSize: 12,
        defaultHeight: 368,
      },
      large: {
        breakpoint: 1400,
        minCardSize: 4,
        maxCardSize: 12,
        defaultHeight: 368,
      },
    },
    toolbar: {
      ids: {
        addCardButton: 'btn-add-card',
      },
      items: [
        {
          type: 'button',
          id: 'btn-add-card',
          classes: ['btn', 'btn-default'],
          textKey: 'Dashboard_AddCard',
        },
      ],
    },
  };
}

function getWelcomeConfig() {
  return {
    defaultName: 'welcome',
    defaultDragAndDrop: false,
    defaultDebug: false,
    layoutOptions: {
      small: {
        breakpoint: 0,
        minCardSize: 12,
        maxCardSize: 12,
        defaultHeight: 368,
      },
      medium: {
        breakpoint: 1046,
        minCardSize: 6,
        maxCardSize: 12,
        defaultHeight: 368,
      },
    },
  };
}

export const dashboardConfig = {
  getDefaultConfig() {
    return getDefaultConfig();
  },
  getWelcomeConfig() {
    return getWelcomeConfig();
  },
};
